import { createApi } from '@reduxjs/toolkit/query/react';

import { Notistack } from '@/app/shared/components/Notistack';
import { getError } from '@/app/shared/utils/helpers';
import { baseQuery } from '@/store/api/baseQuery';
import { setUILoading } from '@/store/reducers/uiSlice';
import type { DocumentsResponse, IStip } from './stips.types';

export const stipsApi = createApi({
  reducerPath: 'stipsApi',

  baseQuery,

  tagTypes: ['Stips'],

  endpoints: (builder) => ({
    fetchStips: builder.query<DocumentsResponse, string>({
      query: (contactId) => ({
        url: `/cpdocuments/contacts/${contactId}`,
        method: 'GET',
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        dispatch(setUILoading(true));

        try {
          await queryFulfilled;
        } catch (err: any) {
          Notistack.generalError(getError(err));
        } finally {
          dispatch(setUILoading(false));
        }
      },
      providesTags: ['Stips'],
    }),
    fetchStipsDetails: builder.query<IStip, { contactStipId: string; contactId: string }>({
      query: ({ contactStipId, contactId }) => ({
        url: `/${contactStipId}?contactId=${contactId}&excludeFileBinaryContent=false`,
        method: 'GET',
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        dispatch(setUILoading(true));

        try {
          await queryFulfilled;
        } finally {
          dispatch(setUILoading(false));
        }
      },
      providesTags: ['Stips'],
    }),
  }),
});

export const { useFetchStipsQuery, useFetchStipsDetailsQuery, useLazyFetchStipsDetailsQuery } = stipsApi;
